// ── Industrial Skeuomorphism — Light Chassis ──────────────────────────────
export const LIGHT = {
  bg:            "#e0e5ec",
  card:          "#e0e5ec",
  cardHover:     "#d8dde6",
  text:          "#2d3436",
  textSec:       "#4a5568",
  textMuted:     "#636e72",
  textFaint:     "#9aabbf",
  border:        "#babecc",
  borderLight:   "#ffffff",
  borderDark:    "#a3b1c6",
  accent:        "#ff4757",
  accentDark:    "#cc1f2f",
  accentGlow:    "rgba(255,71,87,0.12)",
  inputBg:       "#e0e5ec",
  sectionAlt:    "#d8dde6",
  // Dark panels within light mode (hero, resume, footer)
  darkPanel:     "#2d3436",
  darkPanelSec:  "#3a4452",
  darkPanelText: "#e0e5ec",
  darkPanelMuted:"#8fa0b0",
  darkPanelFaint:"#546470",
  mode:          "light",
};

// ── Industrial Skeuomorphism — Dark Chassis ───────────────────────────────
export const DARK = {
  bg:            "#080b14",   // near-black navy — the floor
  card:          "#0f1623",   // lifted surface — clearly distinct from bg
  cardHover:     "#161e30",
  text:          "#e8edf5",   // bright but not harsh white
  textSec:       "#8fa3c0",
  textMuted:     "#546070",
  textFaint:     "#2a3445",
  border:        "#1a2235",   // visible edge
  borderLight:   "#253048",
  borderDark:    "#050810",
  accent:        "#ff4757",
  accentDark:    "#ff6b78",
  accentGlow:    "rgba(255,71,87,0.16)",
  inputBg:       "#060911",   // recessed inputs sink below card
  sectionAlt:    "#060911",   // alternate sections — darkest surface
  // Dark panels (hero, resume, footer) — blacker than bg
  darkPanel:     "#040710",
  darkPanelSec:  "#0b1020",
  darkPanelText: "#e8edf5",
  darkPanelMuted:"#546070",
  darkPanelFaint:"#2a3445",
  mode:          "dark",
};
